module.exports = __webpack_public_path__ + "img/modern_love_tee-400x520.a3956dad.jpg";